import React, { createContext, useContext, useState } from 'react'

interface IDragDropUploadData {
  isDragActive: boolean
}

interface IDragDropUploadContextType {
  dragDropUploadData: IDragDropUploadData
  setDragDropUploadData: (data: Partial<IDragDropUploadData>) => void
  resetDragDropUploadData: () => void
}

const INITIAL_STATE: IDragDropUploadData = {
  isDragActive: false
}

const DragDropUploadContext = createContext<
  IDragDropUploadContextType | undefined
>(undefined)

export const DragDropUploadProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [data, setData] = useState<IDragDropUploadData>(INITIAL_STATE)

  const setDragDropUploadData = (data: Partial<IDragDropUploadData>) => {
    setData(prev => ({ ...prev, ...data }))
  }

  const resetDragDropUploadData = () => {
    setData(INITIAL_STATE)
  }

  return (
    <DragDropUploadContext.Provider
      value={{
        dragDropUploadData: data,
        setDragDropUploadData,
        resetDragDropUploadData
      }}
    >
      {children}
    </DragDropUploadContext.Provider>
  )
}

export const useDragDropUploadContext = () => {
  const context = useContext(DragDropUploadContext)

  if (!context) {
    throw new Error(
      'useDragDropUploadContext must be used within a DragDropUploadProvider'
    )
  }

  return context
}
